export function ErrorMessage({ children }: { children?: React.ReactNode }) {
  return (
    <div className="text-center text-muted-foreground">{children || 'Une erreur est survenue'}</div>
  );
}
